import { render, staticRenderFns } from "./googlepay.vue?vue&type=template&id=dd8b4378&"
import script from "./googlepay.vue?vue&type=script&lang=js&"
export * from "./googlepay.vue?vue&type=script&lang=js&"
import style0 from "./googlepay.vue?vue&type=style&index=0&id=dd8b4378&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports